// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OrganisationYINC-module__inputBox___3Vuud{border-radius:4px;border:solid 1px #494d56;padding:10px;margin-bottom:5px;width:100%}.OrganisationYINC-module__title___1aZaz{font-weight:bold}.OrganisationYINC-module__note___1l73n{margin-top:10px}.OrganisationYINC-module__error___1fl8q{margin-top:-15px}", ""]);
// Exports
exports.locals = {
	"inputBox": "OrganisationYINC-module__inputBox___3Vuud",
	"title": "OrganisationYINC-module__title___1aZaz",
	"note": "OrganisationYINC-module__note___1l73n",
	"error": "OrganisationYINC-module__error___1fl8q"
};
module.exports = exports;
